module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/feature-report-529d289f2a3b008637efdeff6caf1fec.gif";